// Styre & roller — fra Brreg roller. Ikke tegnet i mockupen, men SPEC §4 forventer en
// roller-liste og dataene finnes; rendres som en glass-rad-tabell i samme stil. Fratrådte
// roller dempes. (Se notes/deviations.)
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import type { BrregRolle } from "../api/types";

interface RollerCardProps {
  roller: BrregRolle[] | undefined;
  isLoading: boolean;
}

export function RollerCard({ roller, isLoading }: RollerCardProps) {
  const active = (roller ?? []).filter((r) => !r.fratraadt);
  const resigned = (roller ?? []).filter((r) => r.fratraadt);
  const ordered = [...active, ...resigned];

  return (
    <div className="glass mb-[18px] px-6 py-[22px]">
      <h2 className="m-0 mb-4 flex justify-between text-[13px] font-semibold text-[var(--sub)]">
        Styre &amp; roller
        <span className="font-medium text-[var(--faint)]">Brreg</span>
      </h2>

      {isLoading ? (
        <div className="space-y-2.5">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-6 bg-[rgba(120,60,10,0.1)]" />
          ))}
        </div>
      ) : ordered.length === 0 ? (
        <p className="text-[13px] text-[var(--faint)]">Ingen registrerte roller.</p>
      ) : (
        <ul className="m-0 list-none p-0">
          {ordered.map((r, i) => (
            <li
              key={`${r.typeKode}-${r.navn}-${i}`}
              className={cn(
                "flex justify-between border-t border-[rgba(120,60,10,0.12)] py-[11px] first:border-t-0",
                r.fratraadt && "opacity-50"
              )}
            >
              <span className="font-semibold text-[var(--ink)]">{r.navn}</span>
              <span className="text-[var(--sub)]">
                {r.type}
                {r.fratraadt && " · fratrådt"}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
